/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapperButton[_ngcontent-%COMP%]{margin:0;padding:0;border-width:0;background-color:transparent}video[_ngcontent-%COMP%]{display:block;margin-left:auto;margin-right:auto;height:23vh;width:100%;-o-object-fit:contain;object-fit:contain;cursor:pointer}img[_ngcontent-%COMP%]{display:block;margin-left:auto;margin-right:auto;max-height:250px;width:100%;-o-object-fit:contain;object-fit:contain;cursor:pointer}"];
export { styles as styles };
